import { render } from "./BindUser.vue?vue&type=template&id=a4af644c"
import script from "./BindUser.vue?vue&type=script&lang=js"
export * from "./BindUser.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__